// 统一管理登录/注册弹窗的组件

import React, { useState, useEffect } from "react";
import { LoginModal } from "./Login";
import { RegisterModal } from "./Register";
import { useUserStore } from "@/store/UserStore";
import { getHistoryList } from "@/api/history";
import ToastEvent from "@/utils/toast-event";

interface AuthControllerProps {
  suppressLoginModal?: boolean;
}

export const AuthController: React.FC<AuthControllerProps> = ({
  suppressLoginModal = false,
}) => {
  const [modal, setModal] = useState<"closed" | "login" | "register">("closed");

  const checkLoginStatus = () => {
    const token = useUserStore.getState().token;
    return !!token;
  };

  useEffect(() => {
    const handleOpenAuthModal = (event: CustomEvent) => {
      const { type } = event.detail;
      if (type === "login" || type === "register") {
        setModal(type);
      }
    };
    window.addEventListener(
      "openAuthModal",
      handleOpenAuthModal as EventListener
    );

    return () => {
      window.removeEventListener(
        "openAuthModal",
        handleOpenAuthModal as EventListener
      );
    };
  }, []);

  useEffect(() => {
    if (suppressLoginModal || checkLoginStatus()) {
      return;
    }
    setModal("login");
  }, [suppressLoginModal]);
  const handleLoginSuccess = () => {
    setModal("closed");
  };
  const handleRegisterSuccess = async () => {
    setModal("closed");
    ToastEvent.success("注册登录成功");
    try {
      await getHistoryList(1, 15);
    } catch (error) {
      console.error("Failed to refresh history after registration:", error);
    }
  };

  const handleModalChange = (open: boolean) => {
    if (open) {
    } else {
      if (!checkLoginStatus()) {
        setModal("closed");
      } else {
        setModal("closed");
      }
    }
  };
  const handleOpenLogin = () => {
    setModal("login");
  };
  const handleOpenRegister = () => {
    setModal("register");
  };

  return (
    <>
      <LoginModal
        open={modal === "login"}
        onOpenChange={handleModalChange}
        onLoginSuccess={handleLoginSuccess}
        onOpenRegister={handleOpenRegister}
      />

      <RegisterModal
        open={modal === "register"}
        onOpenChange={handleModalChange}
        onOpenLogin={handleOpenLogin}
        onRegisterSuccess={handleRegisterSuccess}
      />
    </>
  );
};
